import { render, staticRenderFns } from "./PrazoPagamentoManage.vue?vue&type=template&id=ef12cf76&scoped=true"
import script from "./PrazoPagamentoManage.vue?vue&type=script&lang=js"
export * from "./PrazoPagamentoManage.vue?vue&type=script&lang=js"
import style0 from "./PrazoPagamentoManage.vue?vue&type=style&index=0&id=ef12cf76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef12cf76",
  null
  
)

export default component.exports